import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  useLazyGetEventByIdQuery,
  useJoinEventMutation,
} from "../app/services/eventService";
import {
  useLazyGetPartnerByIdQuery
} from "../app/services/partnerService";
import "../../src/style/css/individualEvent.css";
import { useLazyGetEventTypeByIdQuery } from "../app/services/eventTypeServices";
import Button from "@mui/material/Button";
import { selectCurrentScope } from "../app/auth/authSlice";
import { useSelector } from "react-redux";
import { useGetApproveRejectEventMutation } from "../app/services/eventService";
import { toast } from "react-toastify";
import Spinner from "../Component/spinner/spinner";
import { InputAdornment, Modal, TextField, Typography, Chip } from "@mui/material";
import { useForm } from "react-hook-form";
import { selectCurrentMember } from "../app/features/memberSlice";
import { useGetChapterDetailsByIdQuery, } from "../app/services/chapterServices";
import { useGetSIGGroupByIdQuery } from "../app/services/SIGGroupServices";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import placeholder from "../assets/images/placeholder/placeholder.png";
import { CalendarTodayOutlined, AccessTime } from "@material-ui/icons";


//Modal usage
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: "white",
  boxShadow: 24,
  borderRadius: "5px",
  padding: "20px",
};
const GetSIGDetails = ({ id }) => {
  const { data } = useGetSIGGroupByIdQuery(id);
  return (data ? <div className="row-gap-3 d-flex justify-content-center flex-column  align-items-center">
    <img src={placeholder} alt="Eltai Sig Logo" className="img-fluid" style={{ height: '100px' }} />
    <Typography className="poppins-regular text-center fw-semibold menus-green-color text-capitalize" component={'h5'} variant="h5">{data?.data?.groupName}(ELTAI SIG)</Typography>
    {/* <Typography className="poppins-regular w-50 text-center text-capitalize" style={{ minWidth: '300px' }} component={'p'} variant={'body1'}>D-54 Third Floor,Anandham Apartments, 156, SIDCO Nagar Main Road, Villivakkam, Chennai, Tamilnadu, India - 600049.</Typography> */}
    {/* <Typography className="poppins-regular w-25 text-center menus-green-color" style={{ minWidth: '300px' }} component={'p'} variant={'body1'}>www.eltai.in</Typography> */}
  </div> : <>No Sig Found in this id</>)
}

const GetChapterDetails = ({ id }) => {
  const { data } = useGetChapterDetailsByIdQuery(id);
  return (
    <div className="row-gap-3 d-flex justify-content-center flex-column  align-items-center">
      <img src={data?.data?.imageUrl} alt="Eltai Logo" className="img-fluid" style={{ height: '100px' }} />
      <Typography className="poppins-regular text-center fw-semibold menus-green-color text-capitalize" component={'h5'} variant="h5">{data?.data?.title}(ELTAI Chapter)</Typography>
      {/* <Typography className="poppins-regular w-50 text-center text-capitalize" style={{ minWidth: '300px' }} component={'p'} variant={'body1'}>D-54 Third Floor,Anandham Apartments, 156, SIDCO Nagar Main Road, Villivakkam, Chennai, Tamilnadu, India - 600049.</Typography> */}
      {/* <Typography className="poppins-regular w-25 text-center menus-green-color" style={{ minWidth: '300px' }} component={'p'} variant={'body1'}>www.eltai.in</Typography> */}
    </div>
  )
}

function IndividualEvent() {
  const { eventId } = useParams();
  const [loading, setLoading] = useState(false);
  const [getEventById] = useLazyGetEventByIdQuery();
  const [getEventData, setGetEventData] = useState([]);
  const [getEventTypeById] = useLazyGetEventTypeByIdQuery();
  const [getEventType, setGetEventType] = useState([]);
  const [joinEventService] = useJoinEventMutation();
  const memberScope = useSelector(selectCurrentScope);
  const [approveRejectEvent] = useGetApproveRejectEventMutation();
  const memberDetail = useSelector(selectCurrentMember);
  const [open, setOpen] = useState(false);
  const [nonMemberRegisterOpen, setNonMemberRegisterOpen] = useState(false);
  const [partnerGetById] = useLazyGetPartnerByIdQuery()
  const [partnerNames, setPartnerNames] = useState({});
  const today = new Date(new Date().toISOString().split('T')[0]);
  const eventDeadline = getEventData?.deadline ? new Date(new Date(getEventData?.deadline).toISOString().split('T')[0]) : ''
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
    setError,
    clearErrors,
    watch,
    reset,
  } = useForm({
    defaultValues: {
      rejectionReason: "",
    },
  });

  const {
    reset: resetNonMemberForm,
    register: nonMemberRegisterForm,
    formState: { errors: nonMemberFormError },
    handleSubmit: handleSubmitEventNonMember,
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      phone: "",
    },
  });

  //Modal usage
  const handleOpen = (id) => {
    setOpen(true);
  };

  //close handle
  const handleClose = () => {
    setOpen(false);
    setNonMemberRegisterOpen(false);
    reset();
    resetNonMemberForm();
  };

  //Non member registration
  const handleNonMemberRegistation = () => {
    setNonMemberRegisterOpen(true);
  };

  //Event by id
  useEffect(() => {
    if (eventId) {
      getEventById(eventId);
    }
  }, [getEventById, eventId]);



  useEffect(() => {
    const fetchPartnerNames = async () => {
      let names = {};
      const partnerSponsors = getEventData?.sponsors?.filter(s => s.sponsor === "Partner");

      if (partnerSponsors) {
        await Promise.all(partnerSponsors.map(async (sponsor) => {
          if (sponsor.partnerId) {
            const res = await partnerGetById(sponsor.partnerId);
            names[sponsor.partnerId] = res?.data?.data?.partnerName || "Unknown Partner";
          }
        }));
        setPartnerNames(names);
      }
    };

    fetchPartnerNames();
  }, [getEventData, partnerGetById]);


  //Handle approve or reject events with reason
  const handleApproveReject = (id, type) => {
    const rejectionReason = getValues("rejectionReason");
    let data;
    if (type === 0) {
      data = {
        eventId,
        type: type,
      };
    }
    if (type === 1) {
      if (
        rejectionReason === null ||
        rejectionReason === undefined ||
        rejectionReason === ""
      ) {
        setError(
          "rejectionReason",
          { type: "required", message: "Please Enter a Reason For Rejection" },
          { shouldFocus: true }
        );
        return;
      } else {
        clearErrors();
        data = {
          eventId,
          type: type,
          rejectionReason,
        };
      }
    }
    setLoading(true);
    handleClose();
    approveRejectEvent(data).then((res) => {
      if (res.data?.status) {
        setLoading(false);
        toast.success(res?.data?.message);
        if (memberScope === "PORTAL_SUPER_ADMIN") {
          window?.history?.back()
        }
        else {
          window?.history?.back()
        }
      } else {
        setLoading(false);
        toast.error(data.data?.message);
      }
    });
  };

  //Format date
  const formatDate = (dateStr) => {
    const options = { day: 'numeric', year: 'numeric', month: 'long' }; // Options for formatting
    return new Date(dateStr).toLocaleDateString('en-GB', options); // 'en-US' specifies the format
  };


  //Event details by id
  const getEventDetailsById = useCallback(() => {
    setLoading(true);
    getEventById(eventId)
      .then((res) => {
        if (res.data?.status) {
          setLoading(false);
          setGetEventData(res.data.data);
          getEventTypeById(res.data.data.eventTypeId).then((res) => {
            if (res.data?.status) {
              setGetEventType(res.data.data);
            }
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [getEventById, getEventTypeById, eventId]);

  useEffect(() => {
    if (eventId) {
      getEventDetailsById();
    }
  }, [getEventDetailsById, eventId]);

  //Join non member event
  const joinEvent = (event) => {
    if (memberScope === null || memberScope === undefined) {
      handleNonMemberRegistation();
    } else {
      setLoading(true);
      const data = { eventId: event._id, memberId: memberDetail._id };
      joinEventService(data).then((res) => {
        if (res.data?.status) {
          setLoading(false);
          toast.success(res.data.message);
          handleClose();
          reset();
          getEventDetailsById();
        } else {
          setLoading(false);
          toast.error(res.data.err.message);
        }
      });
    }
  };

  //Join non member register
  const nonMemberRegister = (registerData) => {
    const data = {
      eventId: eventId,
      nonMemberDetails: registerData,
    };
    setLoading(true);
    joinEventService(data).then((res) => {
      setLoading(false);
      if (res?.data?.status) {
        toast.success(res?.data?.message);
        setNonMemberRegisterOpen(false);
        resetNonMemberForm();
      } else {
        setLoading(false);
        toast.error(res?.data?.err?.message);
      }
    });
  };


  return (
    <div className='page-containter event-page' style={{ minHeight: '100vh', paddingBottom: '40px' }}>
      <div className='pt-5 mb-3'></div>
      {loading ? (
        <Spinner />
      ) : (
        <div className="container-fluid px-md-5 px-3">

          {/* Back Button */}
          <div className="text-end mb-3">
            <Button
              onClick={() => window.history.back()}
              variant="outlined"
              className="menus-color"
              sx={{ fontWeight: 600 }}
            > Back
            </Button>
          </div>

          {/* HERO SECTION */}
          <div className="event-hero-section">
            <div className="text-center">
              <Chip
                label={`${getEventData?.levelOfEvent || ''} ${getEventType?.name || ''}`}
                sx={{ backgroundColor: '#c40000', color: 'white', fontWeight: 'bold', mb: 2 }}
              />
              <Typography variant="h1" className="event-hero-title poppins-bold">
                {getEventData?.title}
              </Typography>

              <div className="event-hero-meta poppins-regular">
                <div className="event-hero-meta-item">
                  <CalendarTodayOutlined fontSize="small" />
                  <span>
                    {formatDate(getEventData?.startDate)}
                    {getEventData?.endDate ? ` to ${formatDate(getEventData?.endDate)}` : ''}
                  </span>
                </div>
                {getEventData?.startTime && (
                  <div className="event-hero-meta-item">
                    <AccessTime fontSize="small" />
                    <span>{getEventData?.startTime} to {getEventData?.endTime}</span>
                  </div>
                )}
                {getEventData?.venue && (
                  <div className="event-hero-meta-item">
                    <LocationOnIcon fontSize="small" />
                    <span>{getEventData?.venue}</span>
                  </div>
                )}
                {getEventData?.platform && getEventData.platform !== "undefined" && (
                  <div className="event-hero-meta-item">
                    <VideoCallIcon fontSize="small" />
                    <span>{getEventData?.platform}</span>
                  </div>
                )}
              </div>

              <div className="mt-4">
                {getEventData?.mapLink && (
                  <Button
                    variant="contained"
                    startIcon={<LocationOnIcon />}
                    href={getEventData?.mapLink}
                    target="_blank"
                    sx={{ backgroundColor: 'white', color: '#1e3c32', mr: 2, '&:hover': { backgroundColor: '#f0f0f0' } }}
                  >
                    Google Map Link
                  </Button>
                )}
                {getEventData?.meetingURL && (
                  <Button
                    variant="contained"
                    startIcon={<VideoCallIcon />}
                    href={getEventData?.meetingURL}
                    target="_blank"
                    sx={{ backgroundColor: 'white', color: '#1e3c32', '&:hover': { backgroundColor: '#f0f0f0' } }}
                  >
                    Meeting Link
                  </Button>
                )}
              </div>
            </div>
          </div>

          <div className="row g-5">
            {/* LEFT COLUMN: ABOUT, SPEAKERS, ATTACHMENTS */}
            <div className="col-lg-8">

              {/* About the Event */}
              <div className="mb-5">
                <Typography variant="h4" className="event-section-title poppins-bold">About the Event</Typography>
                <div className="poppins-regular justified fs-5 event-description" dangerouslySetInnerHTML={{ __html: getEventData?.description }} style={{ color: '#333', lineHeight: '1.8' }} />
              </div>

              {/* Resource Persons (Speakers) */}
              {getEventData?.speakers && getEventData.speakers.length > 0 && (
                <div className="mb-5">
                  <Typography variant="h4" className="event-section-title poppins-bold">Resource Persons</Typography>
                  <div className="row g-4">
                    {getEventData.speakers.slice().sort((a, b) => a.orderOfSpeaker - b.orderOfSpeaker).map((speaker, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="event-card p-4 d-flex flex-column h-100 bg-white">
                          <img src={speaker?.photo || placeholder} alt={speaker?.name} className="speaker-avatar rounded-circle object-fit-cover shadow-sm" />
                          <div className="text-center">
                            <Typography variant="subtitle2" sx={{ color: '#c40000', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 1, mb: 1 }}>{speaker?.role}</Typography>
                            <Typography variant="h6" className="poppins-bold mb-1" sx={{ color: '#1e3c32' }}>{speaker?.name}</Typography>
                            <Typography variant="body2" className="poppins-regular mb-3" sx={{ color: '#666' }}>{speaker?.designation}, {speaker?.institution}</Typography>
                            <Typography variant="body2" className="poppins-regular justified text-muted" sx={{ fontSize: '0.9rem' }}>{speaker?.bio}</Typography>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Attachments */}
              {(getEventData?.flyer || getEventData?.schedule || getEventData?.brouchure || getEventData?.readingMaterial) && (
                <div className="mb-5">
                  <Typography variant="h4" className="event-section-title poppins-bold">Attachments</Typography>
                  <div className="d-flex flex-wrap gap-3">
                    {getEventData?.flyer && (
                      <Button variant="outlined" href={getEventData?.flyer} target="_blank" className="attachment-btn" sx={{ color: '#1e3c32', borderColor: '#1e3c32', '&:hover': { backgroundColor: '#1e3c32', color: 'white' } }}>Flyer / Poster</Button>
                    )}
                    {getEventData?.brouchure && (
                      <Button variant="outlined" href={getEventData?.brouchure} target="_blank" className="attachment-btn" sx={{ color: '#1e3c32', borderColor: '#1e3c32', '&:hover': { backgroundColor: '#1e3c32', color: 'white' } }}>Brochure</Button>
                    )}
                    {getEventData?.schedule && (
                      <Button variant="outlined" href={getEventData?.schedule} target="_blank" className="attachment-btn" sx={{ color: '#1e3c32', borderColor: '#1e3c32', '&:hover': { backgroundColor: '#1e3c32', color: 'white' } }}>Schedule</Button>
                    )}
                    {getEventData?.readingMaterial && (
                      <Button variant="outlined" href={getEventData?.readingMaterial} target="_blank" className="attachment-btn" sx={{ color: '#1e3c32', borderColor: '#1e3c32', '&:hover': { backgroundColor: '#1e3c32', color: 'white' } }}>Reading Material</Button>
                    )}
                  </div>
                </div>
              )}

            </div>

            {/* RIGHT COLUMN: REGISTRATION, CONTACT, ORGANISERS, SPONSORS */}
            <div className="col-lg-4">
              <div className="join-btn-sticky d-flex flex-column gap-4">

                {/* Registration Card */}
                <div className="event-card registration-card p-4">
                  <Typography variant="h5" className="poppins-bold mb-3" sx={{ color: '#1e3c32' }}>Registration</Typography>

                  <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                    <Typography className="poppins-regular fw-semibold text-muted">Type</Typography>
                    <Typography className="poppins-regular fw-bold">{getEventData?.isPaidEvent === 0 ? 'Free' : 'Paid'}</Typography>
                  </div>

                  {getEventData?.isPaidEvent === 1 && (
                    <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                      <Typography className="poppins-regular fw-semibold text-muted">Fee Details</Typography>
                      <Typography className="poppins-regular fw-bold">{getEventData?.feeDetails}</Typography>
                    </div>
                  )}

                  {getEventData?.deadline && (
                    <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                      <Typography className="poppins-regular fw-semibold text-muted">Last Date</Typography>
                      <Typography className="poppins-regular fw-bold text-danger">{formatDate(getEventData?.deadline)}</Typography>
                    </div>
                  )}

                  {getEventData?.registrationLink && (
                    <div className="d-flex justify-content-between mb-4 pb-2 border-bottom">
                      <Typography className="poppins-regular fw-semibold text-muted">Link</Typography>
                      <a href={getEventData?.registrationLink} target="_blank" rel="noreferrer" className="poppins-regular fw-bold" style={{ color: '#c40000', textDecoration: 'none' }}>Register Here</a>
                    </div>
                  )}

                  {/* Join Button Logic */}
                  <div className="mt-4">
                    {getEventData?.membersId?.includes(memberDetail?._id) ? (
                      <Button fullWidth variant="contained" sx={{ backgroundColor: '#2e7d32', color: 'white', fontWeight: 'bold', py: 1.5, borderRadius: '30px' }} disabled>
                        Joined
                      </Button>
                    ) : (
                      <>
                        {eventDeadline >= today &&
                          (memberScope === "PORTAL_MEMBER" || !memberScope) &&
                          (
                            ((memberScope === undefined || memberScope === null) && getEventData.isEnableRegistration && getEventData.isPublic) ||
                            (memberScope === "PORTAL_MEMBER" && (getEventData?.isPublic || getEventData.isMember) && getEventData?.isEnableRegistration)
                          ) && (
                            <Button fullWidth variant="contained" sx={{ backgroundColor: '#c40000', color: 'white', fontWeight: 'bold', py: 1.5, borderRadius: '30px', '&:hover': { backgroundColor: '#a00000' } }} onClick={() => joinEvent(getEventData)}>
                              Join Now
                            </Button>
                          )}
                      </>
                    )}
                  </div>

                  {/* Admin Controls */}
                  {(memberScope === "PORTAL_SUPER_ADMIN" || memberScope === "PORTAL_ADMIN") && getEventData.isApproved === 0 && (
                    <div className="mt-3 d-flex gap-2">
                      <Button fullWidth variant="outlined" color="error" onClick={() => handleOpen()}>Reject</Button>
                      <Button fullWidth variant="contained" color="success" onClick={() => handleApproveReject(eventId, 0)}>Approve</Button>
                    </div>
                  )}
                </div>

                {/* Organisers Section */}
                <div className="event-card p-4 bg-white">
                  <Typography variant="h5" className="poppins-bold mb-3" sx={{ color: '#1e3c32' }}>Organised by</Typography>
                  <div className="d-flex flex-column gap-3">
                    {/* Render Main Organisers */}
                    {getEventData?.jointOrganisers && getEventData?.jointOrganisers.filter(o => o.levelOfOrganiser === "Main Organiser").sort((a, b) => a.orderOfOrganiser - b.orderOfOrganiser).map((org, idx) => (
                      <div key={idx} className="sponsor-logo-container p-2 text-center shadow-none border">
                        {org.jointOrganiser === 'ELTAI' && (
                          <><img src={`${process.env.REACT_APP_PUBLIC_URL}/assets/images/logos/ELTA@I.svg`} alt="ELTAI" className="sponsor-logo" /><Typography variant="caption" className="fw-bold">ELTAI</Typography></>
                        )}
                        {org.jointOrganiser === 'ELTAI SIG' && <GetSIGDetails id={org?.SIGGroupsId} />}
                        {org.jointOrganiser === 'ELTAI Chapter' && <GetChapterDetails id={org?.chaptersId} />}
                        {org.jointOrganiser === 'Member Institution' && (
                          <><img src={org?.institutionLogo} alt={org?.institutionName} className="sponsor-logo" /><Typography variant="caption" className="fw-bold">{org?.institutionName}</Typography></>
                        )}
                        {org.jointOrganiser === 'Non-Member Institution' && (
                          <><img src={org?.nonMemberLogo} alt={org?.nonMemberName} className="sponsor-logo" /><Typography variant="caption" className="fw-bold">{org?.nonMemberName}</Typography></>
                        )}
                      </div>
                    ))}
                    {/* Render Collaborators */}
                    {getEventData?.jointOrganisers && getEventData.jointOrganisers.some(o => o.levelOfOrganiser !== "Main Organiser") && (
                      <>
                        <Typography variant="subtitle2" sx={{ color: '#c40000', fontWeight: 'bold', mt: 2, mb: 1, textAlign: 'center' }}>In collaboration with</Typography>
                        {getEventData.jointOrganisers.filter(o => o.levelOfOrganiser !== "Main Organiser").sort((a, b) => a.orderOfOrganiser - b.orderOfOrganiser).map((org, idx) => (
                          <div key={`collab-${idx}`} className="sponsor-logo-container p-2 text-center shadow-none border">
                            {org.jointOrganiser === 'ELTAI' && (
                              <><img src={`${process.env.REACT_APP_PUBLIC_URL}/assets/images/logos/ELTA@I.svg`} alt="ELTAI" className="sponsor-logo" /><Typography variant="caption" className="fw-bold">ELTAI</Typography></>
                            )}
                            {org.jointOrganiser === 'ELTAI SIG' && <GetSIGDetails id={org?.SIGGroupsId} />}
                            {org.jointOrganiser === 'ELTAI Chapter' && <GetChapterDetails id={org?.chaptersId} />}
                            {org.jointOrganiser === 'Member Institution' && (
                              <><img src={org?.institutionLogo} alt={org?.institutionName} className="sponsor-logo" /><Typography variant="caption" className="fw-bold">{org?.institutionName}</Typography></>
                            )}
                            {org.jointOrganiser === 'Non-Member Institution' && (
                              <><img src={org?.nonMemberLogo} alt={org?.nonMemberName} className="sponsor-logo" /><Typography variant="caption" className="fw-bold">{org?.nonMemberName}</Typography></>
                            )}
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </div>

                {/* Sponsors Section */}
                {getEventData?.sponsors && getEventData.sponsors.length > 0 && getEventData.sponsors[0].sponsor !== 'None' && (
                  <div className="event-card p-4 bg-white">
                    <Typography variant="h5" className="poppins-bold mb-3" sx={{ color: '#1e3c32' }}>Sponsored by</Typography>
                    <div className="d-flex flex-column gap-3">
                      {getEventData.sponsors.map((sponsor, idx) => (
                        <div key={idx} className="sponsor-logo-container p-2 text-center shadow-none border">
                          {sponsor.sponsor === 'ELTAI' && (
                            <><img src={`${process.env.REACT_APP_PUBLIC_URL}/assets/images/logos/ELTA@I.svg`} alt="ELTAI" className="sponsor-logo" /><Typography variant="caption" className="fw-bold">ELTAI</Typography></>
                          )}
                          {sponsor.sponsor === 'ELTAI SIG' && <GetSIGDetails id={sponsor?.SIGGroupsId} />}
                          {sponsor.sponsor === 'ELTAI Chapter' && <GetChapterDetails id={sponsor?.chaptersId} />}
                          {sponsor.sponsor === 'Partner' && (
                            <><img src={sponsor?.partnerLogo || placeholder} alt="Partner" className="sponsor-logo" /><Typography variant="caption" className="fw-bold">{partnerNames[sponsor?.partnerId] || "Loading..."}</Typography></>
                          )}
                          {sponsor.sponsor === 'Member Institution' && (
                            <><img src={sponsor?.institutionLogo} alt={sponsor?.institutionName} className="sponsor-logo" /><Typography variant="caption" className="fw-bold">{sponsor?.institutionName}</Typography></>
                          )}
                          {sponsor.sponsor === 'Non-Member Institution' && (
                            <><img src={sponsor?.nonMemberLogo} alt={sponsor?.nonMemberName} className="sponsor-logo" /><Typography variant="caption" className="fw-bold">{sponsor?.nonMemberName}</Typography></>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Contact Section */}
                {getEventData?.contacts && getEventData.contacts.length > 0 && (
                  <div className="event-card p-4 bg-white">
                    <Typography variant="h5" className="poppins-bold mb-3" sx={{ color: '#1e3c32' }}>Contact</Typography>
                    <div className="d-flex flex-column gap-3">
                      {getEventData.contacts.map((contact, idx) => (
                        <div key={idx} className="border-bottom pb-2 mb-1 last-border-none">
                          <Typography variant="subtitle2" sx={{ color: '#c40000', fontWeight: 'bold', mb: 0.5 }}>{contact?.role}</Typography>
                          <Typography variant="body1" className="poppins-bold">{contact?.name}</Typography>
                          <Typography variant="body2" className="poppins-regular text-muted mb-1">{contact?.designation}, {contact?.institution}</Typography>
                          <Typography variant="body2" className="poppins-regular"><strong>Phone:</strong> {contact?.mobile}</Typography>
                          <Typography variant="body2" className="poppins-regular"><strong>Email:</strong> {contact?.email}</Typography>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>

          {/* Modals */}
          <Modal open={nonMemberRegisterOpen} onClose={handleClose} aria-labelledby="modal-modal-title">
            <div style={style} className="d-flex container justify-content-start align-items-center flex-column gap-3 rounded-3">
              <Typography component={"h2"} className="text-center fs-4 fw-bold mb-2 code title-font" style={{ color: "brown" }}>
                Non Member Register Event
              </Typography>
              <form onSubmit={handleSubmitEventNonMember(nonMemberRegister)} className="w-100">
                <TextField
                  fullWidth InputLabelProps={{ shrink: true }}
                  label={<Typography className="text-dark content-font">Name <span style={{ color: "red", fontFamily: "code" }}>*</span></Typography>}
                  placeholder="Enter your name" variant="outlined"
                  {...nonMemberRegisterForm("name", { required: "Please enter name" })}
                  error={!!nonMemberFormError?.name} helperText={nonMemberFormError?.name?.message}
                />
                <TextField
                  style={{ marginTop: "20px" }} InputLabelProps={{ shrink: true }} fullWidth
                  label={<Typography className="text-dark content-font">Phone Number <span style={{ color: "red" }}>*</span></Typography>}
                  placeholder="Enter your phone number" variant="outlined"
                  {...nonMemberRegisterForm("phone", { required: "Please enter phone number", validate: (value) => { if (String(value).length !== 10) return "Please enter a valid 10-digit phone number"; } })}
                  error={!!nonMemberFormError?.phone} helperText={nonMemberFormError?.phone?.message}
                />
                <TextField
                  style={{ width: "100%", marginTop: "20px" }} InputLabelProps={{ shrink: true }} fullWidth
                  label={<Typography className="text-dark content-font">Email <span style={{ color: "red" }}>*</span></Typography>}
                  placeholder="Enter your email" variant="outlined"
                  {...nonMemberRegisterForm("email", { required: "Please enter a email", pattern: { value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, message: "Please enter a valid email" } })}
                  error={!!nonMemberFormError?.email} helperText={nonMemberFormError?.email?.message}
                />
                <div className="mt-4 d-flex justify-content-center gap-3">
                  <Button variant="outlined" color="error" onClick={handleClose}>Cancel</Button>
                  <Button className="menus-color" variant="contained" type="submit" style={{ backgroundColor: "brown" }}>Submit</Button>
                </div>
              </form>
            </div>
          </Modal>

          <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title">
            <div style={style} className="d-flex align-items-center container justify-content-start flex-column gap-3 rounded-3">
              <form className="w-100">
                <Typography component={"h2"} className="title-font text-center fs-4 fw-bold mb-3">Reject Event</Typography>
                <TextField
                  inputProps={{ maxLength: "300" }} fullWidth multiline rows={5}
                  label={<Typography className="text-dark content-font">Reason for Rejection <span style={{ color: "red" }}>*</span></Typography>}
                  InputProps={{ endAdornment: (<InputAdornment sx={{ position: 'relative', top: '60px' }} position="end">{300 - (watch("rejectionReason")?.length || 0)}</InputAdornment>) }}
                  error={!!errors?.rejectionReason} helperText={errors?.rejectionReason?.message}
                  {...register("rejectionReason", { required: "Please enter a reason for rejection" })}
                  onChange={(event) => { setValue("rejectionReason", event.target.value); clearErrors("rejectionReason"); }}
                />
                <div className="mt-4 d-flex justify-content-center gap-3">
                  <Button variant="outlined" color="error" className="content-font" onClick={handleClose}>Cancel</Button>
                  <Button className="menus-color content-font" variant="contained" color="success" onClick={() => handleApproveReject(eventId, 1)}>Submit</Button>
                </div>
              </form>
            </div>
          </Modal>

        </div>
      )}
    </div>
  );
}

export default IndividualEvent;
